export const environment = {
    version: 'f88a6102294d592ecc6a6fc2dbfc0a4d6a0291b8',
    production: false,
    kinde_client_id: "6157fef382a14ee7bd85f645e65652b7",
    kinde_url: "https://lobster-test.eu.kinde.com",
    api_url: "https://api.lobster.technology",
    signalR_url: "https://signalr.lobster.technology/signalrHub",
    google_maps_api_key: "AIzaSyAmHBdp5FH3Vbf7Z29iS7glr_lBnq01woY"
};
